<template>
  <BaseModal class="base-overlay-first main-base-modal-first">
    <div class="modal">
      <div class="modal__container">
        <div class="modal__title-container">
          <p class="modal__title typography__headline3">{{ t("auth.registration.title") }}</p>

          <p class="modal__additional typography__body2">{{ t("auth.registration.description") }}</p>
        </div>

        <SharedAuthSocialButtons :columns="2">
          <SharedAuthSocialButton
            project="crm"
            :redirect-to="authSocialRedirectUrl"
            social="vk"
            @click="handleSocialAuth"
          />

          <SharedAuthSocialButton
            project="crm"
            :redirect-to="authSocialRedirectUrl"
            social="yandex"
            @click="handleSocialAuth"
          />

          <SharedAuthSocialButton
            project="crm"
            :redirect-to="authSocialRedirectUrl"
            social="google"
            @click="handleSocialAuth"
          />

          <SharedAuthSocialButton
            project="crm"
            :redirect-to="authSocialRedirectUrl"
            social="mailru"
            @click="handleSocialAuth"
          />
        </SharedAuthSocialButtons>

        <p class="modal__additional typography__body2">{{ t("auth.registration.divider") }}</p>

        <BaseForm
          class="modal__container"
          has-enter-submit
          @submit="(event) => handleSubmit(event)"
        >
          <div class="modal__wrapper">
            <BaseInput2
              v-model="fields.email[0].value"
              v-bind="fields.email[1].value"
              autocomplete="email"
              class="base-input-first"
              :error="errors.email"
              name="email"
              :placeholder="t('auth.registration.inputs.email.placeholder')"
              type="email"
            />

            <BaseInput2
              v-model="fields.password[0].value"
              v-bind="fields.password[1].value"
              autocomplete="password"
              class="base-input-first"
              :error="errors.password"
              name="password"
              :placeholder="t('auth.registration.inputs.password.placeholder')"
              type="password"
            />
          </div>

          <p class="modal__additional typography__label1">
            <BaseToggle2
              v-bind="fields.termsAccepted[1].value"
              v-model="fields.termsAccepted[0].value"
              class="base-checkbox-first"
              :error="errors.termsAccepted"
              name="termsAccepted"
              type="checkbox"
              :class="errors.termsAccepted ? 'checkbox-error' : ''"
            >
              <template #description="{ id }">
                <label :for="id">
                  {{ t("auth.registration.terms.text") }}
                  <BaseLink
                    class="ui-link-secondary"
                    :href="`/${locale}/about/user-agreement`"
                    target="_blank"
                  >
                    {{ t("auth.registration.terms.link") }}
                  </BaseLink>

                  {{ t("auth.registration.terms.and") }}
                  <BaseLink
                    class="ui-link-secondary"
                    :href="`/${locale}/about/privacy-policy`"
                    target="_blank"
                  >
                    {{ t("auth.registration.terms.linkPersonalData") }}
                  </BaseLink>
                </label>
              </template>
            </BaseToggle2>
          </p>

          <div class="modal__buttons">
            <BaseButton2
              class="base-button-extra-big base-button-first base-button-round modal__button"
              class-loader="base-loader-second"
              :loading
              type="submit"
            >
              {{ t("auth.registration.buttonSuccess") }}
            </BaseButton2>

            <p class="typography__body2">
              {{ t("auth.registration.haveAccount") }}

              <BaseModalButton
                class="ui-link-secondary"
                :disabled="loading"
                :modal="SHARED_MODAL.AuthLogin"
              >
                {{ t("auth.registration.buttonLogin") }}
              </BaseModalButton>
            </p>
          </div>
        </BaseForm>
      </div>
    </div>
  </BaseModal>
</template>

<script lang="ts" setup>
const { t, locale } = useI18n();
const { errors, fields, handleSubmit, loading, setFieldError, values } = useAuthRegistrationForm();
const { openNotification } = useNotificationStore();
const route = useRoute();
const queryParameters = route.query;
const url = useRequestURL();

const redirectTo = queryParameters[SHARED_URL_QUERY_PARAMETERS.RedirectTo]
  ? queryParameters[SHARED_URL_QUERY_PARAMETERS.RedirectTo]
  : `/${locale.value}/client/projects`;

// Проверяем, есть ли уже протокол в redirectTo
let authSocialRedirectUrl;
if (typeof redirectTo === "string" && (redirectTo.startsWith("http://") || redirectTo.startsWith("https://"))) {
  // Если это уже полный URL - используем как есть
  authSocialRedirectUrl = redirectTo;
} else {
  // Если это относительный путь - добавляем origin
  authSocialRedirectUrl = `${url.origin}${redirectTo}`;
}

const handleSocialAuth = (event: Event) => {
  // if (!values.termsAccepted) {
  //   event.preventDefault();
  //   const errorMessage = t("auth.registration.errorTermsRequired");
  //   setFieldError("termsAccepted", errorMessage);
  //
  //   openNotification(errorMessage, {
  //     type: "error",
  //   });
  //
  //   return false;
  // }

  return true;
};
</script>

<style scoped>
.modal {
  display: flex;
  flex-direction: column;
  row-gap: 32px;
}

@media (--desktop) {
  .modal {
    row-gap: 40px;
  }
}

.modal__title-container {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}

@media (--desktop) {
  .modal__title-container {
    row-gap: 4px;
  }
}

.modal__title {
  color: var(--grey-1-5);
}

.modal__wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 12px;
}

.modal__additional {
  color: var(--grey-3);
}

.modal__container {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.modal__buttons {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 16px;
  color: var(--grey-1-5);
}

@media (--desktop) {
  .modal__buttons {
    flex-direction: row;
    align-items: center;
    column-gap: 16px;
  }
}

.modal__button {
  width: 100%;
}

@media (--desktop) {
  .modal__button {
    width: auto;
  }
}

.checkbox-error {
  color: var(--red) !important;
}

:deep .base-toggle__container a {
  display: inline;
}
</style>
